import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefcheckliste-hinzufuegen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefchecklisteHinzufuegenEffects {

    PruefchecklisteHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFCHECKLISTE_HINZUFUEGEN),
        mergeMap((x: ac.PostPruefchecklisteHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefchecklisteHinzufuegen(x.pruefchecklisteModelRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefchecklisteHinzufuegenErfolgreichAction(x.pruefchecklisteModelRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefchecklisteHinzufuegenFehlerAction(error, x.pruefchecklisteModelRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
